var $dee9868b6fa95ffe$exports = {};
$dee9868b6fa95ffe$exports = {
  "buttonLabel": "Mostrar sugest\xF5es",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " op\xE7\xE3o");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " op\xE7\xF5es");
      }
    }), " dispon\xEDvel.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Grupo inserido ".concat(args.groupTitle, ", com ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " op\xE7\xE3o");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " op\xE7\xF5es");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", selecionado",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Sugest\xF5es",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", selecionado");
  }
};
export { $dee9868b6fa95ffe$exports as default };